// Shared by the standalone and Country-scoped Cities lists to resolve a
// city's map coordinates, falling back to geocoded coordinates keyed by city id.
export const getCityCoords = (cityItem, geocodedCoords = {}) => {
    const lat = cityItem?.latitude;
    const lng = cityItem?.longitude;
    const latNum = Number(lat);
    const lngNum = Number(lng);

    if (
        lat !== null && lat !== undefined &&
        lng !== null && lng !== undefined &&
        !Number.isNaN(latNum) && !Number.isNaN(lngNum) &&
        (latNum !== 0 || lngNum !== 0)
    ) {
        return { lat: latNum, lng: lngNum };
    }

    const cityId = String(cityItem?._id || '');
    return geocodedCoords[cityId] || null;
};
